import dayjs from 'dayjs';

export default {
  dateFormat: 'DD-MM-YYYY',
  dateTimeFormat: 'DD-MM-YYYY HH:mm:ss',
  csvDateFormat: 'YYYY-MM-DD',
  csvDateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
  dateFormatToReplace: [/(\d{2})\/(\d{2})\/(\d{4})/g],
  formatDate(value, isCsvDownload = false) {
    if (!value || value === '0000-00-00') {
      return '';
    }
    const date = dayjs(value);
    return date.isValid() ? date.format(isCsvDownload ? this.csvDateFormat : this.dateFormat) : '';
  },

  formatDateFromStr(value) {
    if (!value) {
      return '';
    }
    this.dateFormatToReplace.forEach((regex) => {
      const datesArray = [...value.matchAll(regex)].map(match => match[0]);
      datesArray.forEach((dateString) => {
        const [day, month, year] = dateString.split('/');
        const date = new Date(`${year}-${month}-${day}`);
        const formattedDate = this.formatDate(date).toString();
        value = value.replace(dateString, formattedDate);
      });
    });

    return value;
  },

  formatDateTime(value) {
    if (!value || value === '0000-00-00 00:00:00') {
      return '';
    }
    const date = dayjs(value);
    return date.isValid() ? date.format(this.dateTimeFormat) : '';
  },
};
